import React from 'react';
import { isDirty } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { messages as acctSetMsgs } from './AccountSettings.i18n';

export const renderUserName = (username) => () => (
  <p aria-labelledby="usernameLabel username" tabIndex="0">
    <label className="form-label bold" id="usernameLabel">
      <FormattedMessage { ...acctSetMsgs.accountSettings.label.username } />
    </label>&nbsp;
    <span className="form-control-static" id="username">
      { username }
    </span>
  </p>
);

export const renderStateMessage = (stateMessage, className) => () => (
  <p className={className} data-qa-item="stateMessage" tabIndex="0">
    <FormattedMessage { ...stateMessage } />
  </p>
);

export const isContactFormDirty = (formState) =>
  isDirty('contactform')(formState);

export const renderButton = (config) => (
  <a role="button" className="btn btn-outline-secondary btn-light mb-2"
    tabIndex="0"
    data-qa-item={config.qaTag}
    key={config.key}
    style={{ marginRight: '3px' }}
    aria-describedby={config.ariaDescribedby}
    onClick={config.onClick}
  >
    <FormattedMessage { ...config.label } />
  </a>
);
